<template>
	<div class="locale-changer">
		<el-select v-model="selectedLang" placeholder="Select">
			<el-option
				v-for="(lang, i) in langs"
				:key="`Lang${i}`"
				:label="getLangLabel(lang)"
				:value="lang"
			/>
		</el-select>
	</div>
</template>

<script>
import { loadLanguageAsync } from '@/i18n'
import userapi from '@/api/user'

export default {
	name: "locale-changer",
	data() {
		return {
			langs: ["es-ES", "en-US", "pt-BR"],
			selectedLang: this.$i18n.locale
		}
	},
	watch: {
		selectedLang(newLang) {
			loadLanguageAsync(newLang).then(() => {
				userapi.changeLanguague(newLang)
			})
		}
	},
	methods: {
		getLangLabel(lang) {
			const messages = this.$i18n.getLocaleMessage(this.$i18n.locale)
			return messages?.languages?.[lang] || lang
		}
	}
}
</script>
